module.exports = __webpack_public_path__ + "static/media/solar-panel-roof.5f188f08.jpg";